module.exports = ".upper-dropdown {\n  top: inherit!important;\n  bottom: 40px;\n}\n.div-one-line {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dropdown/dropdown.component.less
// module id = ./src/app/shared/components/dropdown/dropdown.component.less
// module chunks = main